export enum BaseDataList {
  EMPLOYEES = 'baseData_category_employees',
  RESIDENTS = 'baseData_category_residents',
  DOCTORS = 'baseData_category_doctors',
  CONTACTS = 'baseData_category_contacts',
  ACCOUNTS = 'baseData_category_accounts',
  SUPERVISORS = 'baseData_category_supervisors',
  INSURANCE = 'baseData_category_insurance',
  WELFARE_OFFICES = 'baseData_category_welfareOffices',
}
